import { render } from "./RequestsRecieved.vue?vue&type=template&id=136dd220&scoped=true"
import script from "./RequestsRecieved.vue?vue&type=script&lang=js"
export * from "./RequestsRecieved.vue?vue&type=script&lang=js"

import "./RequestsRecieved.vue?vue&type=style&index=0&id=136dd220&scoped=true&lang=css"

import exportComponent from "D:\\Vue\\Course\\Section16\\main-prj-01-starting-setup\\main-prj-01-starting-setup\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-136dd220"]])

export default __exports__